import { render, staticRenderFns } from "./educationAdmin.vue?vue&type=template&id=48f4869b&scoped=true"
import script from "./educationAdmin.vue?vue&type=script&lang=js"
export * from "./educationAdmin.vue?vue&type=script&lang=js"
import style0 from "./educationAdmin.vue?vue&type=style&index=0&id=48f4869b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4869b",
  null
  
)

export default component.exports